import React from 'react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../store/reportStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { Circles } from '../common/loadingComponent';
import NoDataComponent from '../common/noDataComponent';
import QuickReportFinStatementsInfo from './quickReportSections/quickReportFinStatementsInfo';
import QuickReportFinDataUpdate from './quickReportSections/quickReportFinDataUpdate';

import './finStatements/finStatements.scss';

class FinStatementsInfo extends React.Component {

    get section() {
        return this.props.sections.find(o => o.id === this.props.sectionId).subsections.find(q => q.id === this.props.subsectionId);
    }

    componentDidMount = () => {
        this.props.loadIfExpanded(this.props.sectionId);
    }

    render() {
        const { id, data, isLimited, dataHash, loadingMoreData } = this.section;

        if (loadingMoreData)
            return <Circles />

        if (isNullOrUndefined(data) || isNullOrUndefined(data.statementInfo) || isNullOrUndefined(data.dataUpdate))
            return <NoDataComponent />

        return this.renderContent(id, data, isLimited, dataHash);
    }

    renderContent = (sectionId, data, isLimited, dataHash) => {
        return (
            <>
                <div>
                    <QuickReportFinStatementsInfo sectionId={sectionId} data={data.statementInfo} isLimited={isLimited} dataHash={dataHash} id={this.props.id} reportType={this.props.reportType} />
                </div>
                <QuickReportFinDataUpdate sectionId={sectionId} data={data.dataUpdate} isLimited={isLimited} dataHash={dataHash} id={this.props.id} reportType={this.props.reportType} />
            </>
        );
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(FinStatementsInfo));